import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import MobileChat from './pages/MobileChat.js';
import { AuthProvider } from './context/AuthContext.js';
import './index.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element #root not found');
}

const isMobile = window.location.pathname.startsWith('/mobile');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    {isMobile ? (
      <AuthProvider>
        <MobileChat />
      </AuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
